import {
    ChannelInviteModalViewProps, ErrorTypes,
} from './types'

import {
    HeroCheckCircleIconSolid,
    HeroExclamationTriangleIcon,
    HeroXMarkIcon, KeyIcon,
} from 'components/Icon'

import {
    ModalContent,
    ModalFooter,
    ModalHeader,
} from '../index'

import {
    acceptWrapper, checkItem, checkList, contentWrapper, overflowWrapper, userInfo,
} from './styles/ChannelInviteView'

import Button from 'components/Button'

import {Icon} from 'components/Icon/types'
import {InfoMessage} from 'components/InfoMessage'
import Modal from '../Modal'
import React from 'react'
import User from 'components/User'

import {styled} from 'stitches/config'
import {
    useTranslation,
} from 'react-i18next'


const StyledUserInfo = styled('div', userInfo)
const StyledButtonAcceptWrapper = styled('div', acceptWrapper)
const StyledCheckList = styled('ul', checkList)
const StyledCheckItem = styled('li', checkItem)
const StyledContentWrapper = styled('div', contentWrapper)
const StyledOverflowWrapper = styled('div', overflowWrapper)

const ChannelInviteModalView = (props: ChannelInviteModalViewProps): React.ReactElement => {
    const {
        channelAttrs,
        channelUnsilence,
        describeError,
        joinError,
        onAccept,
        onDecline,
        realmAttrs,
        userAttrs,
        realmMember,
        userId,
    } = props

    const {t} = useTranslation()

    return (
        <Modal onClose={onDecline}>
            <ModalHeader icon={KeyIcon} title={t('Channel invitation')} type='success' />
            <ModalContent>
                <StyledContentWrapper>
                    {describeError?.type === ErrorTypes.expired
                        ? <> </>
                        : (
                            <>
                                <StyledUserInfo>
                                    <div><User avatarOnly userId={userId || ''} /></div>
                                    <StyledOverflowWrapper multiline>
                                        {realmMember
                                            ? t('{{name}} wants to invite you to channel and organization', {name: userAttrs?.name}) :
                                            t('{{name}} wants to invite you to channel', {name: userAttrs?.name})}
                                    </StyledOverflowWrapper>
                                </StyledUserInfo>
                                <div>
                                    <StyledOverflowWrapper><strong>{channelAttrs?.name}</strong></StyledOverflowWrapper>
                                    <StyledOverflowWrapper>{realmAttrs?.name}</StyledOverflowWrapper>
                                </div>
                                <div>
                                    <div>{t('Channel topic:')} {channelAttrs?.topic}</div>
                                </div>
                                <StyledCheckList>
                                    {realmMember ?
                                        <StyledCheckItem>
                                            <div><HeroCheckCircleIconSolid size={24} /></div>
                                            <StyledOverflowWrapper multiline>{t('You are given organization membership to {{name}}', {name: realmAttrs?.name})}</StyledOverflowWrapper>
                                        </StyledCheckItem>
                                        : ''}
                                    {channelUnsilence ?
                                        <StyledCheckItem>
                                            <HeroCheckCircleIconSolid size={24} />{t('You will be un-silenced automatically and can comment without moderation')}
                                        </StyledCheckItem>
                                        : ''}
                                </StyledCheckList>
                            </>
                        )}
                    <div>
                        {describeError ?
                            <InfoMessage
                                icon={HeroExclamationTriangleIcon}
                                infoHeader={describeError.title}
                                message={describeError.text}
                                variant='error'
                            />
                            : null}
                        {joinError ?
                            <InfoMessage
                                icon={HeroExclamationTriangleIcon}
                                infoHeader={joinError.title}
                                message={joinError.text}
                                variant='error'

                            />
                            : null}
                    </div>
                </StyledContentWrapper>
            </ModalContent>
            <ModalFooter>
                <Button iconLeft={HeroXMarkIcon as unknown as Icon} onPress={onDecline} tabIndex={-1} text={t('Close')} />
                <StyledButtonAcceptWrapper>
                    <Button color='filled' disabled={!!(joinError || describeError)} iconLeft={KeyIcon} margin='left' onPress={onAccept} tabIndex={0} text={t('Accept invite')} />
                </StyledButtonAcceptWrapper>
            </ModalFooter>
        </Modal>
    )
}

export default ChannelInviteModalView
